/**
 * The note on the whole tab — "birthday, hold the dessert for the candle".
 *
 * Above the dishes and boxed, because it is about all of them and is easy to
 * miss among the notes on single dishes. The till can change it while the
 * docket is up, so a screen reader hears the change as well.
 *
 * Shared by a prep docket and the pass, which read it for different reasons:
 * the cook to hold something back, the pass to send it out right.
 */
export function TabNote({ note }: { note: string | null }) {
  if (!note) return null;
  return (
    <p className="dk__tab-note" role="note" aria-live="polite">
      <span className="dk__tab-note-label">Order note</span>
      {note}
    </p>
  );
}
